import React from 'react';

import { Gallery } from 'components/gallery/Gallery';
import { GalleryItem } from 'components/gallery/GalleryItem';
import { Image } from 'components/image/Image';
import { asText } from 'components/rich-text/RichText';

import { IPrismicImage } from 'types/prismicImage';
import { PrismicGalleryFields } from 'types/prismicSlices';

interface IGalleryContainerProps {
  fields: PrismicGalleryFields[];
  display: string;
  isColumnLayout?: boolean;
}

export const GalleryContainer = ({
  fields = [],
  display,
  isColumnLayout = false,
}: IGalleryContainerProps) => {
  return (
    <Gallery display={display} isColumnLayout={isColumnLayout}>
      {fields.map((item: PrismicGalleryFields, i: number) => {
        const image: IPrismicImage = item.image;

        if (!image) {
          return null;
        }

        const caption = item.caption;
        const { dimensions, alt, url, copyright } = image;

        let width;
        let height;
        let isPortrait = true;

        if (dimensions) {
          width = dimensions.width;
          height = dimensions.height;
          isPortrait = width <= height;
        }

        return (
          <GalleryItem key={`galleryImage-${i}`} ratio={isPortrait ? 'portrait' : 'landscape'}>
            <Image
              width={width}
              height={height}
              alt={alt}
              copyright={copyright}
              url={url}
              caption={asText(caption)}
            />
          </GalleryItem>
        );
      })}
    </Gallery>
  );
};
